import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

interface CTASectionProps {
  title?: string;
  description?: string;
  ctaLabel?: string;
  ctaLink?: string;
  badge?: string;
}

const CTASection = ({
  title = "Ready to Digitize Your School?",
  description = "Join the growing number of Ethiopian schools that are modernizing their operations with eSchool. Limited Onboarding for 2026 Schools.",
  ctaLabel = "Request a Free Demo",
  ctaLink = "/contact",
  badge = "Limited Availability",
}: CTASectionProps) => (
  <section className="py-24">
    <div className="container mx-auto px-4 lg:px-8">
      <motion.div
        className="gradient-hero rounded-3xl p-10 md:p-16 text-center shadow-2xl relative overflow-hidden"
      >
        <div className="relative z-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 text-white text-sm font-bold uppercase tracking-wider mb-8">
            {badge}
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-primary-foreground mb-6 leading-tight max-w-3xl mx-auto">
            {title}
          </h2>
          <p className="text-primary-foreground/90 text-lg md:text-xl font-medium max-w-2xl mx-auto mb-10 leading-relaxed">
            {description}
          </p>
          <div className="mt-12 flex items-center justify-center">
            <Link to={ctaLink}>
              <Button size="lg" className="bg-white text-primary hover:bg-white/90 font-bold rounded-full gap-2 px-8 h-14 text-lg">
                {ctaLabel}
                <ArrowRight className="w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>

        {/* Background decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary-dark/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
      </motion.div>
    </div>
  </section>
);

export default CTASection;
